import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import {initReactI18next} from 'react-i18next';
import libDe from 'webapp-lib/assets/translations/de/lib.json';
import libEn from 'webapp-lib/assets/translations/en/lib.json';

import casusDe from '../locale/de/casus.json';
import commonDe from '../locale/de/common.json';
import communicationDe from '../locale/de/communication.json';
import contactsDe from '../locale/de/contacts.json';
import documentsDe from '../locale/de/documents.json';
import invoicingDe from '../locale/de/invoicing.json';
import justitiaDe from '../locale/de/justitia.json';
import logViewDe from '../locale/de/logView.json';
import notesDe from '../locale/de/notes.json';
import notificationsDe from '../locale/de/notifications.json';
import obligationsDe from '../locale/de/obligations.json';
import searchDe from '../locale/de/search.json';
import settingsDe from '../locale/de/settings.json';
import taskDe from '../locale/de/task.json';
import templatesDe from '../locale/de/templates.json';
import timetrackingDe from '../locale/de/timeTracking.json';
import timetrackerDe from '../locale/de/timetracker.json';
import userDe from '../locale/de/user.json';
import casusEn from '../locale/en/casus.json';
import commonEn from '../locale/en/common.json';
import communicationEn from '../locale/en/communication.json';
import contactsEn from '../locale/en/contacts.json';
import documentsEn from '../locale/en/documents.json';
import invoicingEn from '../locale/en/invoicing.json';
import justitiaEn from '../locale/en/justitia.json';
import logViewEn from '../locale/en/logView.json';
import notesEn from '../locale/en/notes.json';
import notificationsEn from '../locale/en/notifications.json';
import obligationsEn from '../locale/en/obligations.json';
import searchEn from '../locale/en/search.json';
import settingsEn from '../locale/en/settings.json';
import taskEn from '../locale/en/task.json';
import templatesEn from '../locale/en/templates.json';
import timetrackingEn from '../locale/en/timeTracking.json';
import timetrackerEn from '../locale/en/timetracker.json';
import userEn from '../locale/en/user.json';

// i18next usage in react component:
// src/modules/invoicing/screens/invoices/invoice-container-details/CasusList.tsx

// Some i18next guidelines:
// - Try to avoid <Trans> components
// - Whenever in something is translated in a react component, use useTranslation and define the namespace

const nameSpaces = [
  'common',
  'documents',
  'communication',
  'contacts',
  'settings',
  'notifications',
  'casus',
  'invoicing',
  'notifications',
  'obligations',
  'task',
  'timeTracking',
  'timetracker',
  'user',
  'templates',
  'taskManagement',
  'lib',
  'logView',
  'notes',
  'search',
  'justitia',
] as const;
export type I18NextNS = (typeof nameSpaces)[number];

// We want to call this on i18n next and export it afterwards
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        casus: casusEn,
        common: commonEn,
        communication: communicationEn,
        contacts: contactsEn,
        invoicing: invoicingEn,
        notifications: notificationsEn,
        task: taskEn,
        templates: templatesEn,
        timetracker: timetrackerEn,
        timeTracking: timetrackingEn,
        obligations: obligationsEn,
        documents: documentsEn,
        user: userEn,
        settings: settingsEn,
        lib: libEn,
        logView: logViewEn,
        notes: notesEn,
        search: searchEn,
        justitia: justitiaEn,
      },
      de: {
        casus: casusDe,
        common: commonDe,
        communication: communicationDe,
        contacts: contactsDe,
        invoicing: invoicingDe,
        notifications: notificationsDe,
        task: taskDe,
        templates: templatesDe,
        timetracker: timetrackerDe,
        timeTracking: timetrackingDe,
        obligations: obligationsDe,
        documents: documentsDe,
        user: userDe,
        settings: settingsDe,
        lib: libDe,
        logView: logViewDe,
        notes: notesDe,
        search: searchDe,
        justitia: justitiaDe,
      },
    },
    fallbackLng: 'de',
    defaultNS: 'common',
    ns: [...nameSpaces],
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
      format: (value, format) => {
        if (value instanceof Date) {
          return moment(value).format(format);
        } else if (moment.isMoment(value)) {
          return value.format(format);
        }

        return value;
      },
    },
  });

export default i18n;
